import { leaveManagementServiceApi } from "../../app/leaveManagementServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  GetLeaveAdjustmentDetailsResponseType,
  GetLeaveAdjustmentParamsType,
  GetLeaveAdjustmentResponseType,
  GetQueryArgsType,
} from "../../types";

export const leaveTypeApi = leaveManagementServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getLeaveTypeList: builder.query({
      query: (queryArgs) => ({
        url: API_URL.getLeaveTypeList,
        ...queryArgs,
      }),
      providesTags: ["GetLeaveTypeList"],
    }),
    getLeaveTypeDetails: builder.query({
      query: (id) => ({
        url: `${API_URL.getLeaveTypeDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetLeaveTypeListDetails", id }],
    }),
    addLeaveType: builder.mutation({
      query: (data) => ({
        url: API_URL.addLeaveType,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetLeaveTypeList"],
    }),
    updateLeaveType: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateLeaveType}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetLeaveTypeList",
            {
              type: "GetLeaveTypeListDetails",
              id,
            },
          ];

        return [];
      },
    }),
    getLeaveAdjustmentList: builder.query<
      GetLeaveAdjustmentResponseType,
      GetQueryArgsType<GetLeaveAdjustmentParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getLeaveAdjustmentList,
        ...queryArgs,
      }),
      providesTags: ["GetLeaveAdjustmentList"],
    }),
    getLeaveAdjustmentDetails: builder.query<
      GetLeaveAdjustmentDetailsResponseType,
      number
    >({
      query: (id) => ({
        url: `${API_URL.getLeaveAdjustmentDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetLeaveAdjustmentDetails", id }],
    }),
    addAdjustment: builder.mutation({
      query: (data) => ({
        url: API_URL.addAdjustment,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetLeaveAdjustmentList"],
    }),
    updateAdjustment: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateAdjustment}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetLeaveAdjustmentList",
            {
              type: "GetLeaveAdjustmentDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateAdjustmentStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateAdjustmentStatus}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetLeaveAdjustmentList",
            {
              type: "GetLeaveAdjustmentDetails",
              id,
            },
          ];

        return [];
      },
    }),
    deleteAdjustment: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.deleteAdjustment}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetLeaveAdjustmentList",
            {
              type: "GetLeaveAdjustmentDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetLeaveTypeListQuery,
  useGetLeaveTypeDetailsQuery,
  useUpdateLeaveTypeMutation,
  useAddLeaveTypeMutation,
  useAddAdjustmentMutation,
  useGetLeaveAdjustmentDetailsQuery,
  useGetLeaveAdjustmentListQuery,
  useUpdateAdjustmentMutation,
  useUpdateAdjustmentStatusMutation,
  useDeleteAdjustmentMutation,
} = leaveTypeApi;
